import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import LinkIntercept from 'components/linkIntercept/LinkIntercept';
import { mediaQueries } from 'styles/utils/mediaQueries';

function TravelSafeLinkComponent() {
  return (
    <LinkIntercept to={'/travel-safe'} target={'_blank'}>
      <Wrapper>
        <Image icon={'shield-virus'} />
        <Text>
          <Title>
            <FormattedMessage
              id={'packageCard.travelSafe.label'}
              description={'Travel Safe'}
              defaultMessage={'Travel Safe'}
            />
          </Title>
          <Info>
            <FormattedMessage
              id={'travelSafe.bannerLink.message'}
              description={
                'Clean hotels. 100% flexible cancellation. Personal service and cost protection in case of quarantine.'
              }
              defaultMessage={
                'Clean hotels. 100% flexible cancellation. Personal service and cost protection in case of quarantine.'
              }
            />
          </Info>
        </Text>
      </Wrapper>
    </LinkIntercept>
  );
}

export default TravelSafeLinkComponent;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4em;
  font-weight: 600;
  vertical-align: middle;
  color: ${({ theme }) => theme.colors.text.dark};

  ${mediaQueries.fromAndAbove.desktop`
    justify-content: initial;
  `}
`;

const Image = styled(FontAwesomeIcon)`
  width: 20px !important;
  height: 20px;
  margin-right: 16px;
  margin-left: 2px;
  color: ${({ theme }) => theme.colors.severity.info[0]};
`;

const Text = styled.div`
  margin-top: 3px;
`;

const Title = styled.div`
  text-decoration: underline;
`;

const Info = styled.div`
  margin-top: 8px;
  font-weight: 500;
`;
